import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import AutoFocus from '../AutoFocus'

import closeImg from 'Assets/x-icon-gray.svg'

import panelStyle from 'Styles/panel.css'
import buttonStyle from 'Styles/button.css'
import style from './style.css'

export default function CompletedActivityModal (props) {
  function renderCoachButton () {
    if (props.coachButtonText) {
      return (
        <div>
          <button
            className={classnames(buttonStyle.rectangle, style.coachButton, 'btn-cdl-main')}
            onClick={props.onClickCoachButton}
          >
            {props.coachButtonText}
          </button>
        </div>
      )
    }
  }

  return (
    <div className={classnames(panelStyle.large, style.container)} data-test-id="quizCompleteModal">
      <button
        className={classnames(buttonStyle.rectangle, style.hideModal)}
        onClick={props.onClick}
      >
        <img
          src={closeImg}
          alt="Close this message"
          className={style.closeIcon}
        />
      </button>
      <AutoFocus>
        <h3 className={style.congratulationText}>Congratulations!</h3>
        <p className={style.textInfoModal}>
          You've completed the activity, but you can keep answering questions for practice.
          (Your grade won't be affected.)
        </p>
        {renderCoachButton()}
      </AutoFocus>
    </div>
  )
}

CompletedActivityModal.propTypes = {
  onClick: PropTypes.func.isRequired,
  coachButtonText: PropTypes.string,
  onClickCoachButton: PropTypes.func
}
